module.exports = __webpack_public_path__ + "media/icons/icon-medal-first-3ef6dc0d.svg";